import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { DynIcon } from "@/components/site/DynIcon";
import { Reveal } from "@/components/site/kit";
import { cycleLabel, inr, useApi } from "@/lib/api";

export const ProductCard = ({ p, i = 0 }) => (
  <Reveal delay={(i % 3) * 0.08} className="h-full">
    <article className="card-base card-hover flex h-full flex-col p-7" data-testid={`product-card-${p.slug}`}>
      <div className="flex items-start justify-between gap-3">
        <span className="grid h-14 w-14 place-items-center rounded-2xl bg-[#EEF6FC] text-ocean"><DynIcon name={p.icon} className="h-7 w-7" /></span>
        <span className="rounded-full bg-page px-3 py-1 text-xs font-semibold text-muted2">{p.category}</span>
      </div>
      <h3 className="mt-6 text-xl font-bold">{p.title}</h3>
      <p className="mt-2 flex-1 text-sm leading-relaxed text-body">{p.short_description}</p>
      {p.price ? <p className="mt-4 font-heading text-lg font-bold text-navy">{inr(p.price)} <span className="text-xs font-medium text-muted2">{cycleLabel(p.billing_cycle)}</span></p> : null}
      <div className="mt-6 flex flex-wrap items-center gap-3 border-t border-line pt-5">
        <Link to={`/products/${p.slug}`} className="inline-flex items-center gap-1.5 text-sm font-bold text-ocean hover:gap-2.5 transition-[gap]" data-testid={`product-learn-more-${p.slug}`}>Learn More <ArrowRight className="h-4 w-4" /></Link>
        <Link to={`/products/${p.slug}#demo`} className="ml-auto rounded-full bg-cta px-4 py-2 text-xs font-bold text-navy transition-colors hover:bg-cta-hover" data-testid={`product-request-demo-${p.slug}`}>Request Demo</Link>
      </div>
    </article>
  </Reveal>
);

export const ProductGrid = ({ limit }) => {
  const { data } = useApi("/products");
  const items = (data || []).slice(0, limit || 100);
  return (
    <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="products-grid">
      {items.map((p, i) => <ProductCard key={p.id} p={p} i={i} />)}
    </div>
  );
};
